// extracted by mini-css-extract-plugin
export default {"configLink":"Config_configLink__j1G8H"};